require("!!/Users/vogel/Entwicklung/Workspace/neonis-app-bookings/node_modules/script-loader/addScript.js")(require("!!/Users/vogel/Entwicklung/Workspace/neonis-app-bookings/node_modules/raw-loader/index.js!/Users/vogel/Entwicklung/Workspace/neonis-app-bookings/www/lib/ionic/js/ionic-angular.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./www/lib/ionic/js/ionic-angular.js
// module id = 489
// module chunks = 0